import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Safely access localStorage only on the client side
 * This prevents hydration mismatches
 */
export function safeLocalStorage() {
  if (typeof window === "undefined") {
    return {
      getItem: () => null,
      setItem: () => { },
      removeItem: () => { },
      clear: () => { },
    };
  }
  return localStorage;
}

/**
 * Check if we're on the client side
 */
export function isClient() {
  return typeof window !== "undefined";
}

/**
 * Get a value from localStorage safely
 */
export function getLocalStorageItem(key: string): string | null {
  if (!isClient()) return null;
  return localStorage.getItem(key);
}

/**
 * Set a value in localStorage safely
 */
export function setLocalStorageItem(key: string, value: string): void {
  if (!isClient()) return;
  localStorage.setItem(key, value);
}

/**
 * Remove a value from localStorage safely
 */
export function removeLocalStorageItem(key: string): void {
  if (!isClient()) return;
  localStorage.removeItem(key);
}

export function generateUniqueKey(base: string | number): string {
  return `react-key-${base}`;
}
